import styled from "styled-components";

export const GraficosTankes = styled.div`
  width: 100%;
  height: 99%;
  position: relative;
  .conteinerIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    color: rgba(141, 141, 141, 1);
    font-size: 45px;
    right: 6%;
    top: -5px;
    span {
      font-size: 18px;
      position: absolute;
      top: 17px;
      left: 12px;
    }
  }
  h2 {
    color: rgba(199, 199, 199, 1);
  }
  .headerGrafic {
    display: flex;
    gap: 15px;
    .neveisButton {
      margin: 6px;
      display: flex;
      gap: 5px;
      span {
        color: rgba(187, 187, 187, 1);
      }
      button {
        cursor: pointer;
        width: 30px;
        height: 15px;
        background-color: rgba(215, 215, 215, 0.6);
        transition: 0.5s;
      }
      button:hover {
        background-color: rgba(215, 215, 215, 1);
      }
    }
  }
  .not404 {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    color: rgba(255, 255, 255, 1);
  }
  .ListDate {
    position: absolute;
    right: 11%;
    top: 0px;
    select {
      background-color: rgba(0, 0, 0, 0.3);
      color: rgba(204, 204, 204, 1);
      width: 70px;
      height: 35px;
      border-radius: 5px;
      border: 2px solid rgba(121, 121, 121, 1);
      padding-left: 7px;
    }
  }
  .calendarDiv {
    display: flex;
    align-items: center;
    z-index: 9;
    padding-top: 50px;
    gap: 20px;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgb(0, 0, 0);
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.65) 70%,
      rgba(0, 0, 0, 0) 100%
    );
    .closeModal {
      position: absolute;
      right: 32%;
      font-size: 30px;
      cursor: pointer;
      color: rgba(199, 198, 198, 1);
      transition: 0.5s;
    }
    .closeModal:hover {
      color: white;
    }
    h3 {
      font-size: 25px;
      text-shadow: 3px 1px 5px rgba(0, 0, 0, 0.64);
      color: rgba(212, 212, 212, 1);
    }
    .calendar {
      border-radius: 20px;
      overflow: auto;
      /* background-color: rgba(35, 35, 35, 0.82); */
      .react-calendar__navigation button {
        background-color: rgba(0, 0, 0, 0.5); /* Cor de fundo do botão */
        color: white; /* Cor do texto */
        border: none; /* Removendo a borda padrão */
      }
    }
    .buutons {
      display: flex;
      justify-content: center;
      gap: 20px;
      width: 350px;
      max-width: 100%;
      button {
        padding: 10px 20px;
        cursor: pointer;
        border-radius: 8px;
        font-size: 16px;
      }
    }
  }

  &.graficoHistorico {
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);

    .headerHistorico {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      min-height: 58px;
      padding: 6px 58px 6px 4px;

      .tituloHistorico {
        min-width: 0;

        > span {
          display: block;
          margin-bottom: 2px;
          color: rgba(183, 183, 183, 0.82);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.11em;
          text-transform: uppercase;
        }

        h2 {
          overflow: hidden;
          color: rgba(221, 218, 216, 0.96);
          font-size: clamp(18px, 1.7vw, 24px);
          line-height: 1.1;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .filtrosHistorico {
        display: flex;
        align-items: flex-end;
        gap: 8px;

        .filtroPeriodo {
          display: flex;
          flex-direction: column;
          gap: 3px;

          > span {
            color: rgba(183, 183, 183, 0.78);
            font-size: 10px;
            font-weight: 600;
          }

          select {
            height: 34px;
            padding: 0 28px 0 10px;
            color: rgba(229, 226, 224, 0.92);
            color-scheme: dark;
            background: rgba(0, 0, 0, 0.16);
            border: 1px solid rgba(190, 190, 190, 0.42);
            border-radius: 6px;
            font: inherit;
            font-size: 12px;
            cursor: pointer;

            option {
              color: rgba(245, 242, 240, 0.96);
              background: rgb(67, 83, 89);
            }
          }
        }

        .seletorData {
          height: 34px;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 0 10px;
          color: rgba(229, 226, 224, 0.92);
          background: rgba(0, 0, 0, 0.16);
          border: 1px solid rgba(190, 190, 190, 0.42);
          border-radius: 6px;
          font: inherit;
          font-size: 12px;
          cursor: pointer;
          transition: background 160ms ease, border-color 160ms ease;

          svg {
            color: rgba(199, 199, 199, 0.9);
            font-size: 17px;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.08);
            border-color: rgba(210, 210, 210, 0.58);
          }
        }
      }
    }

    .graficoCanvas {
      position: relative;
      min-height: 0;

      .estadoHistorico {
        position: absolute;
        inset: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 4px;
        color: rgba(190, 190, 190, 0.82);
        background: rgba(55, 70, 76, 0.66);
        font-size: 12px;
        pointer-events: none;

        strong {
          color: rgba(231, 228, 226, 0.94);
          font-size: 15px;
        }
      }
    }

    .calendarDiv {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      display: grid;
      place-items: center;
      padding: 14px;
      background: rgba(28, 37, 40, 0.62);
      backdrop-filter: blur(4px);

      .calendarioCard {
        width: min(350px, 100%);
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px;
        color: rgba(239, 236, 234, 0.96);
        background: rgba(67, 83, 89, 0.98);
        border: 1px solid rgba(205, 205, 205, 0.24);
        border-radius: 10px;
        box-shadow: 0 18px 45px rgba(0, 0, 0, 0.28);

        > header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;

          span {
            color: rgba(205, 201, 198, 0.78);
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 0.1em;
            text-transform: uppercase;
          }

          h3 {
            margin-top: 2px;
            color: rgba(245, 242, 240, 0.96);
            font-size: 18px;
            text-shadow: none;
          }

          .closeModal {
            position: static;
            width: 30px;
            height: 30px;
            display: grid;
            flex: 0 0 auto;
            place-items: center;
            color: rgba(225, 222, 220, 0.88);
            background: rgba(190, 190, 190, 0.1);
            border: 1px solid rgba(205, 205, 205, 0.2);
            border-radius: 6px;

            svg {
              font-size: 18px;
            }
          }
        }

        .calendar {
          width: 100%;
          max-height: 285px;
          padding: 6px;
          color: rgba(239, 236, 234, 0.94);
          background: rgba(0, 0, 0, 0.12);
          border: 1px solid rgba(205, 205, 205, 0.16);
          border-radius: 8px;

          button {
            color: inherit;
            background: transparent;
            border: 0;
            border-radius: 5px;
            cursor: pointer;
          }

          .react-calendar__navigation button {
            color: rgba(239, 236, 234, 0.94);
            background: transparent;
          }

          .react-calendar__tile:enabled:hover,
          .react-calendar__tile:enabled:focus,
          .react-calendar__navigation button:enabled:hover {
            background: rgba(205, 205, 205, 0.14);
          }

          .react-calendar__tile--active {
            color: #ffffff;
            background: rgba(175, 175, 175, 0.5);
          }
        }

        .buutons {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 8px;

          button {
            padding: 8px 12px;
            color: rgba(234, 231, 229, 0.94);
            background: transparent;
            border: 1px solid rgba(205, 205, 205, 0.22);
            border-radius: 6px;
            font: inherit;
            font-size: 12px;

            &.acaoPrincipal {
              color: #ffffff;
              background: rgba(164, 164, 164, 0.58);
            }
          }
        }
      }
    }
  }

  @media (max-width: 720px) {
    &.graficoHistorico {
      .headerHistorico {
        align-items: flex-start;
        flex-direction: column;
        gap: 7px;
        padding: 5px 48px 5px 2px;

        .filtrosHistorico {
          align-items: center;

          .filtroPeriodo > span {
            display: none;
          }
        }
      }
    }
  }
`;
